<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
      </page-header>
    </page-main>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return {
      usePage: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzRepReplenishReorderTimePeriodListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>翻单
<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin: 0 !important;
}
::v-deep .is-active {
  color: #409eff !important;
}
</style>
